import * as React from 'react'
import styles from './Loader.module.scss'

interface Props {
	className?: string
}

const Loader: React.FC<Props> = (props) => (
	<div className={`${styles.loader} ${props.className}`}>
		<div className={styles.ball_pulse}>
			<div></div>
			<div></div>
			<div></div>
		</div>
	</div>
)

export default Loader
